import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Inspector from 'react-inspector';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { getCompanyDunIdByName } from '../actions';
import { selectCompanyDunIdByName } from '../selectors';
import { selectWork } from '../../Api/selectors';
import { COMPANY_DUN } from '../constants';
import { Loader } from '../../../components/Loader';
import { VBox } from '../../../components/Box';
import { FormControl, Input } from '../../../components/Input';

const CardContainer = styled.div``;

const STATE = {
  countryCode: 'NL',
};

class CompanyDunPage extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  retrieve() {
    this.props.retrieve(this.state.countryCode.toUpperCase(), (result) => {
      //debugger;
    });
  }

  render() {
    if (this.props.loading) return <Loader small />;
    return (
      <CardContainer>
        <h2>Dun</h2>
        <VBox>
          Country-code
          <FormControl>
            <Input name="countryCode" value={this.state.countryCode} onChange={this.onInputChange.bind(this)} />
          </FormControl>
          <Button small onClick={this.retrieve.bind(this)}>
            Get data
          </Button>
        </VBox>
        {this.renderIdByName()}
      </CardContainer>
    );
  }

  renderIdByName() {
    if (!this.props.idByName) return;
    return <Inspector data={this.props.idByName} expandLevel={20}></Inspector>;
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    idByName: selectCompanyDunIdByName(ownProps.company.id),
    loading: selectWork(COMPANY_DUN),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    retrieve(countryCode, callback) {
      dispatch(getCompanyDunIdByName(ownProps.company.id, countryCode, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyDun = compose(withConnect, withRouter)(CompanyDunPage);
